<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Blyd and Pearce</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Kim Fielding</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Born into poverty and orphaned young, Daveth Blyd had one chance for success when his fighting prowess earned him a place in the Tangye city guard—a place he lost to false accusations of theft. Now he scrapes out a living searching for wayward spouses and missing children. When a nobleman offers him a small fortune to find an entertainer who’s stolen a ring, Daveth takes the case.</p>
<p class="P_Normal">While Jory Pearce may or may not be a thief, he certainly can’t be trusted. But, enchanted by Jory’s beauty and haunting voice, Daveth soon finds himself caught in the middle of a conspiracy. As he searches desperately for answers, he realizes that he’s also falling for Jory. On their search for the truth, the two men face river wraiths, assassins, a necromancer, and a talking head that could be Daveth’s salvation. But with everyone’s integrity in question and Death eager to dance, Daveth will need more than sorcery to survive.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?2a2df739